var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 1307,
    viewBox: "0 0 1440 1307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "194.3%",
    height: "219.4%",
    x: "-47.2%",
    y: "-59.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 50
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "213.2%",
    height: "243.2%",
    x: "-56.6%",
    y: "-71.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 50
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "213.2%",
    height: "243.2%",
    x: "-56.6%",
    y: "-71.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1307,
    fill: "#040802"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BFE82D",
    transform: "translate(-156.61 135.768)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1498.888,
    cy: 219.691,
    filter: "url(#a)",
    opacity: 0.148,
    rx: 159,
    ry: 125.666,
    transform: "scale(-1 1) rotate(-27 0 6463.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.601,
    cy: 153.461,
    filter: "url(#b)",
    opacity: 0.2,
    rx: 132.5,
    ry: 104.721,
    transform: "rotate(-27 165.6 153.461)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.109,
    cy: 900.953,
    filter: "url(#c)",
    opacity: 0.2,
    rx: 132.5,
    ry: 104.721,
    transform: "scale(-1 1) rotate(-27 0 2421.743)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.2331cbaca108d511c72a65fe6c3133c6.svg";
export { ForwardRef as ReactComponent };